'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

interface ISideBarData {
  governance?: {
    visible?: boolean;
    selected?: string;
  };
  plugins?: {
    selected?: string;
  };
}

const initialState: ISideBarData = {
  governance: {
    visible: false,
    selected: '',
  },
  plugins: {
    selected: '',
  },
};

const sideBarSlice = createSlice({
  name: 'sideBarData',
  initialState,
  reducers: {
    setSideBarData: (_state, action: PayloadAction<ISideBarData>) => {
      return action.payload;
    },
  },
});

export const { setSideBarData } = sideBarSlice.actions;
export default sideBarSlice.reducer;
export const sideBarDataSelector = (state: RootState) => state.sideBarData;
export const governanceSelector = (state: RootState) =>
  state.sideBarData.governance;
